import { App } from "antd";
import $ from "jquery";
import { useCallback, useLayoutEffect } from "react";
import { runFolderTreeDrop, useJqueryFolderTreeDroppable } from "@devowl-wp/react-folder-tree";
import { RatingPointer } from "@devowl-wp/real-utils";
import { useStores } from "../../store/rootStore.js";
import { __, _n } from "../../utils/i18n.js";
import { request } from "../../utils/request.js";
import { locationRestPostsBulkMovePut } from "../../wp-api/postsBulkMove.put.js";
/**
 * Enables / refresh the droppable nodes. If a draggable item is dropped
 * here the given posts are moved to the category. You have to provide a ReactJS
 * element to reload the tree.
 */ function usePostDroppable(id, makeDraggable) {
    const { message } = App.useApp();
    const { treeStore, optionStore } = useStores();
    const { others: { tableCheckboxName } } = optionStore;
    const onDrop = useCallback(async (event, ui)=>{
        const removeElements = [];
        let hide;
        const iterateChecked = (elem, cb)=>{
            const trs = $(`input[name="${tableCheckboxName}"]:checked`);
            if (trs.length) {
                trs.each(function() {
                    cb($(this).parents("tr"));
                });
            } else {
                cb(elem);
            }
        };
        await runFolderTreeDrop({
            $,
            event,
            ui,
            collect: ()=>{
                const ids = [];
                iterateChecked(ui.draggable.parents("tr"), (tr)=>{
                    ids.push(parseInt(tr.find(`input[name="${tableCheckboxName}"]`).attr("value"), 10));
                    removeElements.push(tr);
                });
                return {
                    ids
                };
            },
            onBefore: ({ ids, isCopy, folderName })=>{
                removeElements.forEach((obj)=>$(obj).fadeTo(250, 0.3));
                const i18nProps = {
                    count: ids.length,
                    category: folderName
                };
                hide = message.loading(isCopy ? _n("Copying post to %(category)s...", "Copying %(count)d posts to %(category)s...", ids.length, i18nProps) : _n("Moving post to %(category)s...", "Moving %(count)d posts to %(category)s...", ids.length, i18nProps));
            },
            execute: async ({ ids, isCopy, to, treeAttributes })=>{
                await request({
                    location: locationRestPostsBulkMovePut,
                    request: {
                        ids,
                        isCopy,
                        taxonomy: treeAttributes.tax,
                        to: +to
                    }
                });
            },
            onSuccess: ({ ids, isCopy, folderName })=>{
                hide?.();
                const i18nProps = {
                    count: ids.length,
                    category: folderName
                };
                const { isRatable, slug } = optionStore;
                isRatable && new RatingPointer(slug, $(event.target));
                message.success(isCopy ? _n("Post successfully copied.", "%(count)d posts successfully copied.", ids.length, i18nProps) : _n("Post successfully moved.", "%(count)d posts successfully moved.", ids.length, i18nProps));
                treeStore.fetchTree();
                const elementsIterate = (cb)=>{
                    for(let i = 0; i < removeElements.length; i++){
                        cb(removeElements[i]);
                    }
                };
                if (isCopy) {
                    void (async ()=>{
                        try {
                            const response = await fetch(window.location.href, {
                                credentials: "same-origin"
                            });
                            if (!response.ok) {
                                return;
                            }
                            const doc = $(await response.text());
                            const tableRows = doc.find(".wp-list-table tbody tr");
                            if (!tableRows.length) {
                                return;
                            }
                            let postId;
                            let tableRow;
                            elementsIterate((obj)=>{
                                postId = $(obj).attr("id");
                                tableRow = doc.find(`#${postId}`);
                                $(obj).replaceWith(tableRow);
                            });
                            makeDraggable();
                        } catch  {
                        // Keep the current table state when the refresh request fails.
                        }
                    })();
                } else {
                    elementsIterate((obj)=>$(obj).remove());
                }
                if (!$(".wp-list-table tbody tr").length) {
                    $(".wp-list-table tbody").html(`<tr class="no-items"><td class="colspanchange" colspan="6">${__("No entries")}</td></tr></tbody>`);
                }
            },
            onError: (error)=>{
                hide?.();
                console.log(error);
            }
        });
    }, [
        treeStore,
        optionStore,
        tableCheckboxName,
        message,
        makeDraggable
    ]);
    const { makeDroppable, refreshDroppable } = useJqueryFolderTreeDroppable({
        $,
        root: `#${id}`,
        onDrop
    });
    useLayoutEffect(()=>{
        makeDroppable();
    }, [
        makeDroppable
    ]);
    return {
        makeDroppable,
        refreshDroppable
    };
}
export { usePostDroppable };
